module.exports = __webpack_public_path__ + "media/assets/images/blog/DALL·E_customer_experience-small-0ad8f03cafc06b6f924824753b81c5d1.png";